// 入金主方中的币种映射关系
export enum RecommendCurrencyEnum {
    USD = 1,
    HKD,
    NZD,
    SGD,
    AUD, // 澳大利亚币
    EUR, // 欧元
    MYR, // 马来西亚币
    IDR, // 印尼盾
    THB, // 泰铢
    CAD, // 加拿大币
    GBP, // 英镑
    JPY, // 日元
    VND, // 越南盾
    BRL, // 巴西雷亚尔
    PHP, // 菲律宾比索
    CNH // 离岸人民币
}

// 入金主方式类型映射
export enum RecommendDepositEnum {
    BankSecurities = 1, // 银证转账
    DDA, // DDA
    Transfer, // 转账汇款
    POLI, // POLI入金
    PAYNOW, // PAYNOW入金
    Wise,
    HKDDA, // 香港dda
    PAYID, // pay id
    AKAHU, // nz Akahu 入金
    ACH
}

// 入金主方式类型
export interface RecommendDepositBankBase {
    arrive_time: string; // 到账时间
    currency_type: RecommendCurrencyEnum[]; // 支持币种
    support_bank: string; // 某入金方式所支持的银行
    estimated_cost: string; // 所需手续费用
    recommend_reason: string; // 推荐理由
    is_recommend: 0 | 1; // 是否为推荐入金方式
    type: RecommendDepositEnum; // 推荐入金类型
}

export interface BankSecuritiesGuideItem {
    advantage: string[]; // 优势说明
    bank: string; // 银行名称
    disclaimer: string; // 免责声明
    display_order: number | string;
    logo: string; // 银行 logo 地ZHI
    main_deposit_method: RecommendDepositEnum; // 入金主方式类型
    uuid: string; // 指引 id
}

// 转账汇款页面汇款信息
export interface BankSecuritiesGuideBankInfo {
    // 汇款指南
    banklist: BankSecuritiesGuideItem[];
    need_van_account: boolean;
    // 汇款银行信息
    acclist: Array<{
        label?: React.ReactNode;
        value?: string | number;
        meta?: string;
        name?: string;
    }>;
    accData?: {
        beneficiary_bank: string;
        beneficiary_bank_account: string;
        beneficiary_bank_country_code: string;
    };
}

// 转账汇款中的银行信息
export interface ChoiceItemInfo {
    id: number;
    name: string;
    payee_account_type: string;
}

// 转账汇款中银行对应的类型
export enum ChoiceBankType {
    Basics = 1, // 银行账户
    HKBank,
    USBank,
    NZBank,
    Other,
    SGBank,
    AUBank
}

/**
 * IRA 账户税年额度限制
 */
export interface IRALimits {
    taxYear: string;
    totalLimit: number;
    successDepositAmount: number;
    pendingDepositAmount: number;
    remainingLimit: number;
    remainingLimitWithPendingAmount: number;
}

/**
 * IRA 入金方式
 * RecommendDepositEnum.Transfer 是 wire
 */
export type IRAContributionWays = RecommendDepositEnum.ACH | RecommendDepositEnum.Transfer | 'transfer' | 'check';

export interface CheckGuideInfo {
    beneficiaryAccountTitle: string;
    beneficiaryBankAccount: string;
    beneficiaryCountry: string;
    frontMessage: string;
    mailAddress: string;
    reverseMessage: string;
    beneficiaryName: string;
}

export interface TransferAccount {
    accountId: number;
    brId: string;
    direction: 'ALL' | 'IN' | 'OUT';
    linked: boolean;
    license: 'MARSCO';
    title: string;
}

export interface TaxLimitInfo {
    /** 税年 */
    year: string;
    /** 当次供款支出数额 */
    cost: number;
    /** 当前税年的限额 */
    limit: number;
}

export interface AvailableDipositCash {
    available_deposit_times: number; // 剩余入金次数
    five_day: number; // 剩余可入金金额
    once_deposit: number; // 一次最大入金金额
}
